import { render, staticRenderFns } from "./CancelledOrdersReport.vue?vue&type=template&id=ccbf31b8"
import script from "./CancelledOrdersReport.vue?vue&type=script&lang=js"
export * from "./CancelledOrdersReport.vue?vue&type=script&lang=js"
import style0 from "./CancelledOrdersReport.vue?vue&type=style&index=0&id=ccbf31b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports